import { cancel } from "../Helpers/ExecutionStatus";
import * as DomHelper from "../Helpers/DomHelper";
import * as BlobHelper from "../Helpers/BlobHelper";
const global = window;
const { selfHelp: { resources } } = global;
const { statusIconVals } = DomHelper;
const key = "webWorkers";
let diagnostics;
// Array holds web workers
const workerArr = [];
// Number of workers we'd like to create
const totalWorkers = 6;
// Number of workers that succeeded
let successfulResponses = 0;
// Number that received an error
let failedResponses = 0;
/**
 * Updates blob and updates dom to display results of storage diagnostic tests.
 */
function endTest() {
    if (cancel) {
        return;
    }
    let iconDisplay;
    if (successfulResponses === totalWorkers) {
        iconDisplay = statusIconVals.success;
        diagnostics = {
            success: true,
            details: resources.Worker_success,
        };
    }
    else {
        iconDisplay = statusIconVals.error;
        diagnostics = {
            success: false,
            details: `${resources.Worker_failure.replace("{0}", successfulResponses.toString()).replace("{1}", totalWorkers.toString())}`,
        };
    }
    DomHelper.createMoreDetailsSection(key, diagnostics.details);
    DomHelper.displayStatusIcon(key, iconDisplay);
    BlobHelper.updateBlob(key, diagnostics);
    DomHelper.makeBarGrow(key);
}
/** Tests each worker to ensure that they calculate the correct integer response and that there are no errors in communication */
function testWorkers() {
    workerArr.forEach((ww, i) => {
        ww.postMessage(i);
        ww.onmessage = function (e) {
            if (e.data === Math.pow(8, i) * 143) {
                successfulResponses++;
            }
            ww.terminate();
            if (failedResponses + successfulResponses === totalWorkers) {
                endTest();
            }
        };
        ww.onerror = function () {
            failedResponses++;
            ww.terminate();
            if (failedResponses + successfulResponses === totalWorkers) {
                endTest();
            }
        };
    });
}
/** Ensures web workers available in browser and creates a series from given script */
function createWorkers() {
    if (cancel) {
        endTest();
    }
    if (window.Worker) {
        for (let i = 0; i < totalWorkers; i++) {
            workerArr.push(new Worker("./Content/Scripts/SelfHelp/Helpers/WorkerScript.js"));
        }
        testWorkers();
    }
    else {
        diagnostics = {
            success: false,
            details: resources.Worker_unsupported,
        };
        endTest();
    }
}
/** Restores diagnostics to default values */
function resetDiagnostics() {
    diagnostics = { success: null, details: null };
    successfulResponses = 0;
    failedResponses = 0;
}
/** Triggers beginning of test and update of DOM. */
export function startTest() {
    resetDiagnostics();
    DomHelper.displayStatusIcon(key, statusIconVals.inProgress);
    createWorkers();
}
//# sourceMappingURL=WebWorker.js.map